<p class="modal-title" [innerHtml]="obj.title"></p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p style="padding-top: 15px;" [innerHtml]="obj.content"></p>